<div class="download">
  <ul class="download__list" [ngClass]="modificator ? 'download__list--' + modificator : ''">
    <li
      *ngFor="let file of files"
      class="download__card download__card--uploaded"
      [ngClass]="modificator ? 'download__card--' + modificator : ''"
    >
      <div
        class="download__card-content"
        [class.download-list-bank__item-content]="modificator"
        [ngClass]="{ 'download-pdf-file': !hasFileErrors(file) && file.nativeFile.type === mimeType.pdf }"
      >
        <label class="download__label fade-in" [style.position]="'static'">

          <div class="download__loading" *ngIf="file.isLoading">
            <svg class="download__spinner">
              <circle class="download__spinner-path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
            </svg>
          </div>

          <ng-container *ngIf="!hasFileErrors(file) || file.secureImageSrc">
            <div class="download__icon-pdf" *ngIf="file.nativeFile.type === mimeType.pdf; else fileTpl">
              <img
                class="download__icon-pdf-img"
                src="/cabinet/assets/img/icons/i-pdf.svg"
                [alt]="file.nativeFile.name"
              />
            </div>

            <ng-template #fileTpl>
              <div
                class="download__img"
                [ngClass]="{ 'download__img--error': !file.isLoading && settings.uploadUrl && file.errors.load }"
              >
                <img *ngIf="file.secureImageSrc" [src]="file.secureImageSrc" [alt]="file.nativeFile.name" />
              </div>
            </ng-template>
          </ng-container>

          <span class="download__delete" (click)="onImageFileDelete(file)">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"
                fill="#FF0000"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.6569 8.75744L17.2426 7.34323L13 11.5859L8.75736 7.34323L7.34315 8.75744L11.5858 13.0001L7.34315 17.2427L8.75736 18.6569L13 14.4143L17.2426 18.6569L18.6569 17.2427L14.4142 13.0001L18.6569 8.75744Z"
                fill="white"
              />
            </svg>
          </span>

          <span *ngIf="file.isLoaded" class="download__uploaded">
            <icon src="./assets/img/icons/i-check.svg" color="#FFFFFF" width="21px" height="15px"></icon>
          </span>

          <div
            *ngIf="!file.isLoading && settings.uploadUrl && file.errors.load"
            class="download__retry"
            (click)="handleFileWithServerUpload(file)"
          >
            <icon name="loader" width="24px" height="24px" class="download__retry-icon" color="#FFFFFF"></icon>
          </div>

          <ng-container *ngIf="!file.isLoading && !file.secureImageSrc && hasFileErrors(file)">
            <icon src="./assets/img/icons/file-attach/wrong.svg" width="50px" height="34px"></icon>
          </ng-container>
        </label>
      </div>
      <ng-container *ngIf="file.errors">
        <span *ngIf="file.errors.type" class="error-input">
          <span
            class="error-input__content"
            [innerHTML]="'profile-identity.error.files.type' | translate: { formats: allowedFileTypes }"
          ></span>
        </span>
        <span
          *ngIf="file.errors.size"
          class="error-input__content"
          translate="profile-identity.error.files.size"
          [translateParams]="{ size: settings.allowedFileSize / (1024*1024) }"
        ></span>
        <span *ngIf="file.errors.dimensions" class="error-input">
          <span class="error-input__content" translate="profile-identity.error.files.dimensions"></span>
        </span>
        <span *ngIf="file.errors.load" class="error-input">
          <span
            class="error-input__content"
            translate="profile-identity.error.files.load"
            [translateParams]="{ size: settings.allowedFileSize / (1024*1024) }"
          ></span>
        </span>
      </ng-container>
    </li>

    <li
      #dropArea
      class="download__card download__card--empty"
      [hidden]="files.length >= settings.maxFiles"
      [class.download__card--label]="uploadText"
      [ngClass]="modificator ? 'download__card--' + modificator : ''"
    >
      <div class="download__card-content" [ngClass]="modificator ? 'download__card-content--' + modificator : ''">
        <label class="download__label fade-in" [style.position]="'static'">
          <input
            #fileInput
            type="file"
            name="file"
            hidden
            autocomplete="files"
            data-e2e-element="file-input"
            [multiple]="settings.maxFiles !== 1"
            [accept]="settings.allowedContentTypes"
            (change)="attachFiles($event.target.files)"
            (click)="downloadLabelClicked.next()"
          />
          <input
            type="text"
            name="fakeFileInput"
            class="form-control download__input"
            [formControl]="ctrl"
            (click)="fileInput.click()"
          />
          <p *ngIf="uploadText" class="download__card-text" [translate]="uploadText"></p>
        </label>
      </div>
    </li>

    <ng-container *ngTemplateOutlet="fieldErrors; context: { field: 'files', control: ctrl }"></ng-container>
  </ul>
</div>

<ng-template #fieldErrors let-control="control" let-field="field">
  <div *ngIf="control && control.errors && (control.dirty || control.touched)">
    <span *ngIf="control.errors.maxFiles" class="error-input">
      <span
        class="error-input__content"
        translate="profile-identity.error.files.count"
        [translateParams]="{ count: settings.maxFiles }"
      ></span>
    </span>
  </div>
</ng-template>
